import { render, staticRenderFns } from "./CamaraRegistro.vue?vue&type=template&id=6fcf3ab4&scoped=true&"
import script from "./CamaraRegistro.vue?vue&type=script&lang=ts&"
export * from "./CamaraRegistro.vue?vue&type=script&lang=ts&"
import style0 from "./CamaraRegistro.vue?vue&type=style&index=0&id=6fcf3ab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcf3ab4",
  null
  
)

export default component.exports